<template>
  <a-modal
      :title="`包号：${boxNum} - 订单列表`"
      :width="1200"
      :visible="visible"
      @cancel="handleCancel"
      :footer="null"
      :destroyOnClose="true"
      class="order-list-modal"
  >
    <div class="modal-content">
      <!-- 搜索表单 -->
      <div class="search-container">
        <!-- 搜索表单 -->
        <a-form layout="inline" :form="searchForm" @submit="handleSearch">
          <a-form-item label="标签单号">
            <a-input
                v-decorator="['barCodeNo']"
                placeholder="请输入标签单号"
                style="width: 180px"
            />
          </a-form-item>

          <a-form-item label="运单号">
            <a-input
                v-decorator="['waybillNumber']"
                placeholder="请输入运单号"
                style="width: 180px"
            />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table
          :columns="columns"
          :dataSource="data"
          rowKey="id"
          :pagination="pagination"
          :loading="loading"
          :scroll="{ x: 1500, y: tableScrollY }"
          bordered
          size="middle"
          @change="handleTableChange"
      >
        <template slot="serviceType" slot-scope="text">
          <a-tag>{{ text }}</a-tag>
        </template>

        <template slot="arriveWarehouseTime" slot-scope="text">
          {{ text | formatDateTime }}
        </template>

        <template slot="leaveWarehouseTime" slot-scope="text">
          {{ text | formatDateTime }}
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import {message} from 'ant-design-vue';
import {getOrdersByBoxNum} from 'api/app'

const COLUMNS = [
  {
    title: '标签单号',
    dataIndex: 'barCodeNo',
    align: 'center',
    width: 150
  },
  {
    title: '运单号',
    dataIndex: 'waybillNumber',
    align: 'center',
    width: 150
  },
  {
    title: '收件人姓名',
    dataIndex: 'toCustLinkman',
    align: 'center',
    width: 120
  },
  {
    title: '收件人省州',
    dataIndex: 'toCustCanton',
    align: 'center',
    width: 120
  },
  {
    title: '收件人城市',
    dataIndex: 'toCustCity',
    align: 'center',
    width: 120
  },
  {
    title: '收件人邮编',
    dataIndex: 'toCustZipCode',
    align: 'center',
    width: 100
  },
  {
    title: '收件人电话',
    dataIndex: 'toCustTel',
    align: 'center',
    width: 120
  },
  {
    title: '服务代码',
    dataIndex: 'serviceType',
    scopedSlots: {customRender: 'serviceType'},
    align: 'center',
    width: 100
  },
  {
    title: '包裹重量(KG)',
    dataIndex: 'whtFactWht',
    align: 'center',
    width: 120
  },
  {
    title: '分拣仓称重(kg)',
    dataIndex: 'sortingWeigh',
    align: 'center',
    width: 120
  },
  {
    title: '站点名称',
    dataIndex: 'siteName',
    align: 'center',
    width: 150
  },
  {
    title: '到仓时间',
    dataIndex: 'arriveWarehouseTime',
    align: 'center',
    width: 150,
    scopedSlots: {customRender: 'arriveWarehouseTime'}
  },
  {
    title: '出仓时间',
    dataIndex: 'leaveWarehouseTime',
    align: 'center',
    width: 150,
    scopedSlots: {customRender: 'leaveWarehouseTime'}
  }
]

export default {
  name: 'OrderListModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    boxNum: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      columns: COLUMNS,
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      loading: false,
      firstLoad: true,
      searchForm: this.$form.createForm(this),
      searchParams: {},
      tableScrollY: 400 // 默认高度，将在mounted中动态计算
    }
  },
  filters: {
    formatDateTime(value) {
      if (!value) return '-'
      return value.length > 10 ? value.substr(0, 16) : value
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.firstLoad || this.pagination.current !== 1) {
          this.pagination.current = 1
        }
        this.searchForm.resetFields()
        this.searchParams = {}
        this.fetchData()
        this.firstLoad = false
      }
    },
    mounted() {
      this.calculateTableHeight();
      window.addEventListener('resize', this.calculateTableHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.calculateTableHeight);
    },
    boxNum() {
      if (this.visible) {
        this.pagination.current = 1
        this.fetchData()
      }
    }
  },
  methods: {
    calculateTableHeight() {
      this.$nextTick(() => {
        const modal = document.querySelector('.order-list-modal .ant-modal');
        if (modal) {
          const modalHeight = modal.clientHeight;
          const searchHeight = document.querySelector('.search-container')?.clientHeight || 80;
          const padding = 32; // 上下内边距和其他间距
          const newHeight = modalHeight - searchHeight - padding;
          this.tableScrollY = Math.max(newHeight, 200); // 设置最小高度200px
        }
      });
    },
    fetchData() {
      if (!this.boxNum) return

      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.pageSize,
        boxNum: this.boxNum,
        ...this.searchParams
      }

      getOrdersByBoxNum(params)
          .then(response => {
            this.data = response.data.records || []
            this.pagination.total = response.data.total || 0
          })
          .catch(error => {
            console.error('获取订单列表失败:', error)
            message.error('获取订单列表失败')
          })
          .finally(() => {
            this.loading = false
          })
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    handleCancel() {
      this.$emit('close')
    },
    handleSearch(e) {
      e.preventDefault()
      this.searchForm.validateFields((err, values) => {
        if (!err) {
          this.searchParams = values
          this.pagination.current = 1
          this.fetchData()
        }
      })
    },
    handleReset() {
      this.searchForm.resetFields()
      this.searchParams = {}
      this.pagination.current = 1
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.modal-content {
  padding: 0 8px;
}
.order-list-modal {
  top: 20px;
  bottom: 20px;
}
.search-container {
  padding: 0 8px 16px;
  flex-shrink: 0;
}
/* 修复固定列高度问题 */
:deep(.ant-table-fixed-left) .ant-table-tbody > tr > td,
:deep(.ant-table-fixed-left) .ant-table-thead > tr > th {
  height: 39px; /* middle尺寸的行高 */
}
</style>
